export const apiUrlToId = (url: string): string | undefined => url.split('/').filter(Boolean).pop();
